module.exports = __webpack_public_path__ + "static/media/join_card.eb047b87.jpg";